import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class DeleteAnalyticPlanRules {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(rules_ids: number[], company_id: number): Promise<any> {
    const args = {
      rules_ids,
      company_id
    };
    return await this.dispatcher.dispatch('delete.analytic_plan_rules', args);
  }
}
